<div class="container">
    <div class="row">
        <div class="col p-0">
            <app-reports-filter [selectedReport]="reportModel" [generateDisabled]="generateDisabled"
                [showClassFilter]="true" [classes]="displayedClasses" [instructors]="instructors"
                (filtersSelected)="filterClass($event)" (doFilter)="showReport($event)"
                (generateReport)="generateReportFile($event)">
            </app-reports-filter>
        </div>
    </div>
    <div class="row mt-3" *ngIf="reportData.length > 0">
        <div class="col p-0">
            <div class="row club-centric-report-header align-items-center">
                <div class="col-4 p-0">
                    <div class="row align-items-center">
                        <div class="col-6">{{ 'ClubCentricReport.ClubNameHeader' | translate }}</div>
                        <div class="col-3 text-center">{{ 'ClubCentricReport.TotalHoursHeader' | translate }}</div>
                        <div class="col-3 text-center">{{ 'ClubCentricReport.TotalCostHeader' | translate }}</div>
                    </div>
                </div>
                <div class="col-8 p-0">
                    <div class="row align-items-center">
                        <div class="col-3">{{ 'ClubCentricReport.InstructorHeader' | translate }}</div>
                        <div class="col-3">{{ 'ClubCentricReport.ClassNameHeader' | translate }}</div>
                        <div class="col-2">{{ 'ClubCentricReport.DateTimeHeader' | translate }}</div>
                        <div class="col-3 text-right">
                            {{ 'ClubCentricReport.ActualAndBillableTimeHeader' | translate }}
                        </div>
                        <div class="col-1 text-center">{{ 'ClubCentricReport.CostHeader' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-club-centric-report-item *ngFor="let item of reportData" [summaryItem]="item">
                    </app-club-centric-report-item>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="reportData.length === 0">
        <div class="col text-center">
            <div><span class="ic-binoculars"></span></div>
            <div>{{ 'ClubCentricReport.NoRecords' | translate }}</div>
        </div>
    </div>
</div>
